import config from 'config'
import qs from 'query-string'

import { AbstractService } from 'services/AbstractService'
import { ServiceError } from 'services/errors'
import { SCENE_SOUCE } from '~/shared/constants'
import getLogger from 'shared/logger'

const DEFAULT_PRODUCT_VARIATIONS_QUERY = {} as ProductVariations.ProductVariationsQuery

export class ProductVariationsApi extends AbstractService implements Services.IProductVariationsService {
  public async getProductVariations(query = DEFAULT_PRODUCT_VARIATIONS_QUERY): Promise<ProductVariations.Response> {
    const { templateToken, locale, offset, limit, selectedOptions, noCache, useConstraints, mpvId, searchBackend, debug, productKeys } = query
    const url = `v2/Designs/${templateToken}/Culture/${locale}/ProductVariations`
    const selectedOptionsObj: Util.StringDictionary<string> = {}

    Object.entries(selectedOptions).forEach(([key, value]) => {
      const objKey = `selectedOptions[${key}]`

      selectedOptionsObj[objKey] = value as string
    })
    try {
      const paramsConfig = {
        offset,
        limit,
        requestor: noCache ? config.noCacheRequestor : config.appName,
        noCache,
        useConstraints,
        mpvId,
        includeColorSwatches: true,
        includePreview: true,
        sceneSource: SCENE_SOUCE.SCENE_LOOKUP_SOURCED,
        searchBackend,
        debug,
        productKeys,
        ...selectedOptionsObj,
      }

      const response = await this.api.get(url, {
        params: {
          ...paramsConfig,
        },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'none' }),
      })

      return response?.data
    } catch (e) {
      throw new ServiceError(
        {
          url,
          message: `Bad response from content query service: ${(e as Error).message}`,
          query,
        },
        e as Error,
      )
    }
  }
}

export const ProductVariationsService = new ProductVariationsApi(config.services.designVariationsService, getLogger)
